import { createReducer } from '@reduxjs/toolkit'
import {
  clearAutoTransferFundState,
  clearAutoTransferOrders,
  clearAutoTransferPreOrders,
  clearExchangeRates,
  fetchExchangeRates,
  getAutoTransferOrder,
  getAutoTransferPreOrder,
  goToPrevAutoTranferFundStep,
  setAutoTransferFundStep,
} from './thunk'
import {
  AutoTransferFundsSteps,
  Forex,
  PreOrderWithTransfersResponse,
  ReducerState,
} from 'interfaces'
export interface ExchangeBalanceState {
  prevStep: AutoTransferFundsSteps | null
  currentStep: AutoTransferFundsSteps | null
  stepsHistory: AutoTransferFundsSteps[]
}
interface AutoMoveFundsState extends ReducerState, ExchangeBalanceState {
  target?: string
  exchanges?: Array<Forex>
  cacheDurationInSeconds?: number
  autoTransferOrder?: PreOrderWithTransfersResponse
  autoTransferOrderLoading?: boolean
  autoTransferOrderError?: string
  autoTransferOrderSuccess?: boolean
  autoTransferPreOrderLoading?: boolean
  autoTransferPreOrderError?: string
  autoTransferPreOrderSuccess?: boolean
}

const initialState: AutoMoveFundsState = {
  loading: true,
  error: null,
  target: null,
  exchanges: [],
  cacheDurationInSeconds: null,
  autoTransferOrder: null,
  autoTransferOrderLoading: false,
  autoTransferOrderError: null,
  autoTransferOrderSuccess: false,
  autoTransferPreOrderLoading: false,
  autoTransferPreOrderError: null,
  autoTransferPreOrderSuccess: false,
  stepsHistory: [],
  currentStep: null,
  prevStep: null,
}

const reducers = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchExchangeRates.fulfilled, (acc, { payload }): void => {
      acc.cacheDurationInSeconds = payload?.cacheDurationInSeconds
      acc.exchanges = payload?.exchanges
      acc.target = payload?.target
      acc.error = null
      acc.loading = false
    })
    .addCase(fetchExchangeRates.pending, (acc): void => {
      acc.loading = true
    })
    .addCase(fetchExchangeRates.rejected, (acc, { error }): void => {
      acc.cacheDurationInSeconds = null
      acc.target = null
      acc.exchanges = []
      acc.loading = false
      acc.error = error?.message
    })
    .addCase(getAutoTransferOrder.fulfilled, (acc, { payload }): void => {
      acc.autoTransferOrderLoading = false
      acc.autoTransferOrderError = null
      acc.autoTransferOrderSuccess = true
      acc.autoTransferOrder = payload
    })
    .addCase(getAutoTransferOrder.pending, (acc): void => {
      acc.autoTransferOrderLoading = true
      acc.autoTransferOrderError = null
      acc.autoTransferOrderSuccess = false
    })
    .addCase(getAutoTransferOrder.rejected, (acc, { error }): void => {
      acc.autoTransferOrderLoading = false
      acc.autoTransferOrderError = error?.message
      acc.autoTransferOrderSuccess = false
    })
    .addCase(getAutoTransferPreOrder.pending, (acc) => {
      acc.autoTransferPreOrderLoading = true
      acc.autoTransferPreOrderError = null
      acc.autoTransferPreOrderSuccess = false
    })
    .addCase(getAutoTransferPreOrder.fulfilled, (acc) => {
      acc.autoTransferPreOrderLoading = false
      acc.autoTransferPreOrderError = null
      acc.autoTransferPreOrderSuccess = true
    })
    .addCase(getAutoTransferPreOrder.rejected, (acc, { error }) => {
      acc.autoTransferPreOrderSuccess = false
      acc.autoTransferPreOrderLoading = false
      acc.autoTransferPreOrderError = error.message
    })
    .addCase(clearExchangeRates, (acc): void => {
      acc.cacheDurationInSeconds = null
      acc.target = null
      acc.exchanges = []
      acc.loading = false
      acc.error = null
    })
    .addCase(clearAutoTransferOrders, (acc): void => {
      acc.autoTransferOrder = null
      acc.autoTransferOrderError = null
      acc.autoTransferOrderLoading = false
      acc.autoTransferOrderSuccess = false
    })
    .addCase(clearAutoTransferPreOrders, (acc): void => {
      acc.autoTransferPreOrderError = null
      acc.autoTransferPreOrderLoading = false
      acc.autoTransferPreOrderSuccess = false
    })
    .addCase(goToPrevAutoTranferFundStep, (acc) => {
      acc.stepsHistory.pop()
      acc.prevStep = acc.stepsHistory[acc.stepsHistory?.length - 2]
      acc.currentStep = acc.stepsHistory[acc.stepsHistory?.length - 1]
    })
    .addCase(setAutoTransferFundStep, (acc, { payload }) => {
      acc.prevStep = acc.currentStep
      acc.currentStep = payload
      acc.stepsHistory.push(payload)
    })

    .addCase(clearAutoTransferFundState, (acc) => {
      acc.currentStep = initialState.currentStep
      acc.prevStep = initialState.prevStep
      acc.stepsHistory = initialState.stepsHistory
    })
})

export default reducers
